export default __webpack_public_path__ + "static/media/file.247a54a9.jpeg";